import { useStaticQuery, graphql } from 'gatsby'

export function useDataDevelopment() {
    const data = useStaticQuery(graphql`
        {
            sectionTitle: datoCmsRenshinPageAbout(title: { eq: "Title small" }, locale: { eq: "hy" }) {
                value
            }

            titleOne: datoCmsRenshinPageAbout(title: { eq: "Block 1: Title" }, locale: { eq: "hy" }) {
                value
            }

            textOne: datoCmsRenshinPageAbout(title: { eq: "Block 1: Text" }, locale: { eq: "hy" }) {
                value
            }

            yearOneText: datoCmsRenshinPageAbout(title: { eq: "Block 1: Text left" }, locale: { eq: "hy" }) {
                value
            }

            yearOne: datoCmsRenshinPageAbout(title: { eq: "Block 1: Year" }, locale: { eq: "hy" }) {
                value
            }

            titleTwo: datoCmsRenshinPageAbout(title: { eq: "Block 2: Title" }, locale: { eq: "hy" }) {
                value
            }

            textTwo: datoCmsRenshinPageAbout(title: { eq: "Block 2: Text" }, locale: { eq: "hy" }) {
                value
            }

            textNumberLeft: datoCmsRenshinPageAbout(title: { eq: "Block 2: Text left 1" }, locale: { eq: "hy" }) {
                value
            }

            textNumber: datoCmsRenshinPageAbout(title: { eq: "Block 2: Text left 2" }, locale: { eq: "hy" }) {
                value
            }

            textNumberRight: datoCmsRenshinPageAbout(title: { eq: "Block 2: Text left 3" }, locale: { eq: "hy" }) {
                value
            }

            textNumberBottom: datoCmsRenshinPageAbout(title: { eq: "Block 2: Text left 4" }, locale: { eq: "hy" }) {
                value
            }
        }
    `)

    return data
}
